export interface Config {
  [key: string]: string;
}
